// hooks
import { Fragment, useEffect, useState, useCallback } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import useHttp from "hooks/use-http";

// routes
import { useParams, useNavigate } from "react-router-dom";

// material styles
import { Grid, Button, IconButton, TextField, Tooltip } from "@mui/material";

// material icons
import CheckIcon from "@mui/icons-material/Check";

// components
import LoadingCM from "components/shared/Loading";
import DrawerCM from "components/shared/Drawer";
import TableCM from "components/shared/Table";
import BackButton from "components/shared/BackButton";
import PaginationCM from "components/shared/Pagination";

// helper
import Toast from "helper/toast";

// styled component
import {
  StyledStack,
  StyledTitle,
  ButtonContainer,
} from "./addSubCategory.style";

// request methods
import { addProductsSubCategoryRequest } from "api/requests/products";

// validation
import { categorySchema, validateImg } from "validations";
import Upload from "components/shared/Upload";

export default function AddProductsSubCategory() {
  const { products_category_id } = useParams();

  const navigate = useNavigate();
  const {
    request,
    loading,
    setLoading,
    isUploading,
    uploadProgress,
    setUploadProgress,
  } = useHttp(false);
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(categorySchema),
  });

  // subcategory image state
  const [subCategoryImg, setSubCategoryImg] = useState({
    url: null,
    isChanged: false,
  });

  // image handler
  const imageHandler = (val) => {
    validateImg(val);
    setSubCategoryImg({ url: val, isChanged: true });
  };

  // add subcategory
  const onSubmit = async (data) => {
    const res = await request({
      url: () =>
        addProductsSubCategoryRequest(
          {
            title: data.title,
            parent_id: +products_category_id,
            image: subCategoryImg,
          },
          (progress) => setUploadProgress(progress)
        ),
      isFile: true,
    });

    if (res) {
      reset({
        title: "",
      });
      Toast({ type: "success", title: "ثبت زیردسته " });
      navigate(`/products/category/${products_category_id}/subcategory`);
    }
    setLoading(false);
  };

  return (
    <DrawerCM title="افزودن زیردسته محصولات">
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container>
            <Grid item mt={3} xs={12}>
              <BackButton
                Route={`/products/category/${products_category_id}/subcategory`}
              />
            </Grid>
            <StyledStack>
              <Grid>
                <StyledTitle>افزودن زیردسته</StyledTitle>
                <Grid container>
                  <Grid item md={10} sm={9} xs={12} p={1.5}>
                    <TextField
                      label="عنوان زیردسته"
                      variant="outlined"
                      fullWidth
                      id="title"
                      {...register("title")}
                      error={Boolean(errors.title)}
                      helperText={errors.title?.message}
                    />
                  </Grid>
                  <ButtonContainer item md={2} sm={3} xs={12}>
                    <Button
                      color="success"
                      startIcon={<CheckIcon />}
                      variant="contained"
                      sx={{ mt: 1, mr: 1 }}
                      onClick={handleSubmit(onSubmit)}
                    >
                      ثبت
                    </Button>
                  </ButtonContainer>
                  <Grid item md={6} xs={12} p={1.2}>
                    {subCategoryImg.url ? (
                      <Upload
                        isWeb={subCategoryImg.isWeb}
                        isLocal={!subCategoryImg.isWeb}
                        file={subCategoryImg.url}
                        refillable
                        type="add-image"
                        onChange={imageHandler}
                        width={"100%"}
                        height={"100%"}
                        objectFit="contain"
                      />
                    ) : (
                      <Upload
                        isLocal={subCategoryImg.isChanged}
                        file={subCategoryImg.url}
                        refillable
                        type="add-image"
                        onChange={imageHandler}
                        width={"100%"}
                        height={"100%"}
                        objectFit="contain"
                      />
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </StyledStack>
          </Grid>
        </Fragment>
      )}
    </DrawerCM>
  );
}
